import React from 'react';
import { List, Avatar,Pagination,Select,Button,Radio} from 'antd';
import cbhead from "../../assets/images/cbhead.jpg";
import Axios from 'axios';
import '../../assets/css/list.css';
import {Redirect}from 'react-router-dom';

const { Option } = Select;


let  checkFlag;
class LBlist extends React.Component{


    state={
      name:"",
      //domain:'http://10.0.7.102:3005',
      list:[],
      domain:'',
      regionIdMd:"",
      data:[],
      regionId:"",
      regionName:"",
      userId:"",
      total:7,
      current:1,
      size:7,
      editFlag:false,
      videoAddFlag:false,
      videoEditFlag:false,
      itemId:"",
      radioCityId:"149",
      val:"",
      countyId:"",
  }
     onShowSizeChange = (current, size)=> {
        if(current===""||current===undefined||size===""||size===undefined){
          current=this.state.current
          size=this.state.size
        }
        let  regionId =this.state.regionId;
        let  countyId =this.state.countyId;
        let userId =this.state.userId;
        if(userId==="1"||userId===1){//当为省级的时候
          regionId=this.state.radioCityId;//默认查询郑州
          countyId=this.state.val; 
          if(countyId==="请选择区县"||countyId===null||countyId===undefined){
            countyId="";
          }  
        }
        //分页
        var  params = new URLSearchParams();
        var api =this.state.domain+"/switch/treasure/backend/select";
        params.append("regionIdMd",this.state.regionIdMd);
        params.append("regionId",regionId);
        params.append("countyId",countyId);
        params.append("regionName",this.state.regionName);
        params.append("adminId",this.state.userId);
        params.append("pageNumber",current);
        params.append("pageSize",size);
        Axios.post(api,params)
        .then((res)=>{
            if(res.data.status===1){
              this.setState({
                data:res.data.list,
                total:res.data.total,
                current:current,
                size,size
            })
            }else if(res.data.status===2){
              alert("登录失效!")
              window.location.href='/'
            }else{
              console.log(res.data.message)
            }
       })
      .catch((error)=>{
          console.log(error)
      })   
  }

   delete = (itemId)=>{
        
        var  params = new URLSearchParams();
        var api =this.state.domain+"/switch/treasure/delete";
        params.append("id",itemId);
        params.append("adminId",localStorage.getItem("userId"));
        Axios.post(api,params)
        .then((res)=>{
          this.onShowSizeChange();
       })
      .catch((error)=>{
          console.log(error)
      }) 
  }
     componentDidMount(){
      let regionIdMd = localStorage.getItem("regionIdMd");
      //登录人ID
      let userId = localStorage.getItem("userId");
      let regionId = localStorage.getItem("regionId");
      let countyId =localStorage.getItem("countyId");
      if(userId==="1"||userId===1){//当为省级的时候
        regionId="149";//默认查询郑州
        countyId="";
      }
      let regionName = localStorage.getItem("regionName");
      //调用后台获取区域内村宝信息
      var  params = new URLSearchParams();
      var api =this.state.domain+"/switch/treasure/backend/select";
      params.append("regionIdMd",regionIdMd);
      params.append("regionId",regionId);
      params.append("countyId",countyId);
      params.append("regionName",regionName);
      params.append("adminId",userId);
      params.append("pageNumber",1);
      params.append("pageSize",7);
      Axios.post(api,params)
      .then((res)=>{
           if(res.data===""&&res.status===200){
            alert("登录已失效!")
            window.location.href='/'
           } 
          if(res.data.status===1){
            this.setState({
              data:res.data.list,
              regionIdMd:regionIdMd,
              userId:userId,
              regionId:regionId,
              regionName:regionName, 
              total:res.data.total       
          })
          }else if(res.data.status===2){
            alert("登录失效!")
            window.location.href='/'
          }else{
            console.log(res.data.message)
          }
     })
    .catch((error)=>{
        console.log(error)
    })
    //初始化下拉框
    var  params = new URLSearchParams();
    var api ="/switch/region/get";
    params.append("parentId","149");
    Axios.post(api,params)
    .then((res)=>{       
        if(res.data.status===1){
          this.setState({
            list:res.data.data      
          })
        }else if(res.data.status===2){
          window.location.href='/'
        }else{
          console.log(res.data.message)
        }
    })
    .catch((error)=>{
      console.log(error)
    })
  } 

  edit=(data)=>{
    localStorage.setItem("photo",data.photo);
    localStorage.setItem("description",data.description);
    localStorage.setItem("cbName",data.name);
    localStorage.setItem("cbLable",data.tag);
    localStorage.setItem("cbId",data.id);
     this.setState({
      editFlag:true,
      itemId:data.id
     })
  }
   //添加视频
  videoAdd=(data)=>{
    localStorage.setItem("photo","");
    localStorage.setItem("cbName",data.name);
    localStorage.setItem("cbId",data.id);
    //视频跳转链接
     localStorage.setItem("videoUrl","");
     //视频名字
     localStorage.setItem("videoName","");
     //s视频标签
     localStorage.setItem("vLable","");
    //视频id
    localStorage.setItem("videoId","");
    //开始时间
    localStorage.setItem("startTime","");
      //视频id
    localStorage.setItem("id","");
     this.setState({
      videoAddFlag:true,
      itemId:data.id
     })
  }
  //管理视频
  videoEdit=(data)=>{
    localStorage.setItem("cbName",data.name);
    localStorage.setItem("cbId",data.id);
     this.setState({
      videoEditFlag:true,
      itemId:data.id
     })
  }
  //处理过长文字
  check=(data)=>{
      if(data.length>80){
        return data.substring(0,79)+"......"
      }else{
        return data
      }
  }
 
  rChange=(e)=>{
    //防止离开请求
    if(e.target.value===checkFlag){
      return;
    }
    checkFlag=e.target.value;
    //查询市区数据
    let regionIdMd = localStorage.getItem("regionIdMd");
    //登录人ID
    let userId = localStorage.getItem("userId");
    let regionId = e.target.value;//省级切换
    let countyId =localStorage.getItem("countyId");
    countyId="";
    let regionName = localStorage.getItem("regionName");
    //调用后台获取区域内村宝信息
    var  params = new URLSearchParams();
    var api =this.state.domain+"/switch/treasure/backend/select";
    params.append("regionIdMd",regionIdMd);
    params.append("regionId",regionId);
    params.append("countyId",countyId);
    params.append("regionName",regionName);
    params.append("adminId",userId);
    params.append("pageNumber",1);
    params.append("pageSize",7);
    Axios.post(api,params)
    .then((res)=>{
         if(res.data===""&&res.status===200){
          alert("登录已失效!")
          window.location.href='/'
         } 
        if(res.data.status===1){
          this.setState({
            data:res.data.list,
            regionIdMd:regionIdMd,
            userId:userId,
            regionId:regionId,
            regionName:regionName, 
            total:res.data.total,
            current:1,
            size:7,         
        })
        }else if(res.data.status===2){
          alert("登录失效!")
          window.location.href='/'
        }else{
          console.log(res.data.message)
        }
   })
  .catch((error)=>{
      console.log(error)
  })

    //初始化下拉框 切换地市
    var  params = new URLSearchParams();
    var api ="/switch/region/get";
    params.append("parentId",e.target.value);
    Axios.post(api,params)
    .then((res)=>{       
        if(res.data.status===1){
          this.setState({
            val:"请选择区县",
            list:res.data.data,
            radioCityId:e.target.value,   
          })
        }else if(res.data.status===2){
          window.location.href='/'
        }else{
          console.log(res.data.message)
        }
    })
    .catch((error)=>{
      console.log(error)
    })

  }
  //查询 结果
  search=()=>{
    let  current =1;
    let size =7;
    let  regionId =this.state.radioCityId;
    let  countyId =this.state.val;
    if(countyId==="请选择区县"||countyId===null||countyId===undefined){
      countyId="";
    }
    //分页
    var  params = new URLSearchParams();
    var api =this.state.domain+"/switch/treasure/backend/select";
    params.append("regionIdMd",this.state.regionIdMd);
    params.append("regionId",regionId);
    params.append("countyId",countyId);
    params.append("regionName",this.state.regionName);
    params.append("adminId",this.state.userId);
    params.append("pageNumber",current);
    params.append("pageSize",size);
    Axios.post(api,params)
    .then((res)=>{
        if(res.data.status===1){
          this.setState({
            data:res.data.list,
            total:res.data.total,
            current:current,
            size,size
        })
        }else if(res.data.status===2){
          alert("登录失效!")
          window.location.href='/'
        }else{
          console.log(res.data.message)
        }
   })
  .catch((error)=>{
      console.log(error)
  })   
  }

    render(){
      if(this.state.editFlag){
        return <Redirect to={{pathname: `/pcontent/${this.state.itemId}`} }/>;
      };
      if(this.state.videoAddFlag){
        return <Redirect to={{pathname: `/news/videoAdd/${this.state.itemId}`} }/>;
      };
      if(this.state.videoEditFlag){
        return <Redirect to={{pathname: `/news/videoList/${this.state.itemId}`} }/>;
      };
    return(
          <div>
            <div>
             <img style={{width:'100%'}} src={cbhead} alt="村宝头部"/>
            </div>
            <div style={{display:localStorage.getItem("regionId")==="0"?"block":"none"}}>
            <Radio.Group onChange={(e)=>this.rChange(e)} defaultValue="149" buttonStyle="solid">
              <Radio.Button value="149">郑州</Radio.Button>　
              <Radio.Button value="151">开封</Radio.Button>　
              <Radio.Button value="150">洛阳</Radio.Button>　
              <Radio.Button value="157">平顶山</Radio.Button>　
              <Radio.Button value="152">安阳</Radio.Button>　
              <Radio.Button value="153">鹤壁</Radio.Button>　
              <Radio.Button value="160">新乡</Radio.Button>　
              <Radio.Button value="155">焦作</Radio.Button>　
              <Radio.Button value="166">濮阳</Radio.Button>　
              <Radio.Button value="162">许昌</Radio.Button>　
              <Radio.Button value="165">漯河</Radio.Button>　
              <Radio.Button value="158">三门峡</Radio.Button>　
              <Radio.Button value="159">商丘</Radio.Button>　
              <Radio.Button value="163">周口</Radio.Button>　
              <Radio.Button value="164">驻马店</Radio.Button>　
              <Radio.Button value="156">南阳</Radio.Button>　
              <Radio.Button value="161">信阳</Radio.Button>　
              <Radio.Button value="154">济源</Radio.Button>　
            </Radio.Group>
            <Select
              style={{ width: 150 }}
              showSearch
              allowClear={true}
              value={this.state.val===undefined||this.state.val===""?"请选择区县":this.state.val}
              onChange={val => this.setState({val:val})}      
          >
              {this.state.list.map(item => (
                      <Option key={item.id} value={item.id}>{item.name}</Option>
                 ))
                }
            </Select>,
            <Button onClick={()=>this.search()} style={{float:"right"}} type="primary" htmlType="submit">
               查询
           </Button>　　
        </div>
         <hr/>
            <List
                itemLayout="horizontal"
                dataSource={this.state.data}
                renderItem={item => (
                <List.Item  actions={[ 
                    localStorage.getItem("regionId")==="0"?
                    <a onClick={ (e) => this.edit(item)} key="list-loadmore-edit1">预览村宝信息</a>:
                    <a onClick={ (e) => this.edit(item)} key="list-loadmore-edit1">修改村宝信息</a>,
                    localStorage.getItem("regionId")==="0"?"":
                    <a  onClick={ (e) => this.videoAdd(item)} key="list-loadmore-videoAdd">添加视频</a>,
                    <a  onClick={ (e) => this.videoEdit(item)} key="list-loadmore-videoEdit">视频列表</a>,
                    <a  onClick={ (e) => this.delete(item.id)} key="list-loadmore-delete">删除</a>]}>
                    <List.Item.Meta
                    avatar={<Avatar src={`${item.photo}?x-oss-process=style/cunbaoTouxiang`}/>}
                    title={item.name}
                    description={this.check(item.description)}
                    />
               </List.Item>
            )}      
        />
          <br/><br/>
          <Pagination onChange={this.onShowSizeChange} current={this.state.current}  defaultCurrent={1} defaultPageSize={7} total={this.state.total}/>
          </div>
      )
    }
  }
  
  export default LBlist;


// WEBPACK FOOTER //
// ./src/components/Model/LBlist.js